import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import './Topbar.css';
import { useSectionRefs } from '../../context/SectionRefsContext';

const sections = {
    'public-stories': { authentidatedOnly: false, label: 'navbar.publicStories', icon: (<i className="fa-solid fa-gift"></i>) },
    'favorites': { authentidatedOnly: true, label: 'navbar.favorites', icon: (<i className="fa-solid fa-bookmark"></i>) },
    'my-stories': { authentidatedOnly: true, label: 'navbar.myStories', icon: (<i className="fa-solid fa-book"></i>) },
    'create-story': { authentidatedOnly: true, label: 'navbar.createStory', icon: (<i className="fa-solid fa-wand-sparkles"></i>) }
};

const Topbar = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { isAuthenticated, logout } = useAuth();
    const { activeSection, setActiveSection } = useSectionRefs();

    const { t } = useTranslation();

    const scrollToSection = (id) => {
        const section = sections[id];
        if (section && section.authentidatedOnly && !isAuthenticated) {
            navigate('/login');
        }
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    };

    const handleNavigate = (path) => {
        if (path.startsWith('/')) {
            navigate(path);      
            setActiveSection(path);
        } else {
            if (['/', '/browse-stories'].includes(pathname)) {
                scrollToSection(path);
            } else {
                navigate(`/#${path}`);
                scrollToSection(path);
            }
        }
    }

    return (
        <div className="topbar-mobile">
            <span className="section-icon" onClick={() => handleNavigate(activeSection)}>{sections[activeSection]?.icon}</span>
            <select
                className="section-select"
                value={activeSection}
                onChange={(e) => handleNavigate(e.target.value)}
            >
                {Object.keys(sections).map(
                    (key) => (
                    <option key={key} value={key}>
                        {t(sections[key].label)}
                    </option> 
                    )
                )}
            </select>
            <div className="topbar-actions">
                <button
                    onClick={() => handleNavigate('/profile')}>
                    <i className="fas fa-user"></i>
                </button>
                {isAuthenticated ? (
                    <button
                        onClick={logout}>
                        <i className="fas fa-power-off"></i>
                    </button>
                ) : (
                    <button
                        onClick={() => handleNavigate('/login')}>
                        <i className="fas fa-power-off"></i>
                    </button>
                )}
            </div>
        </div>
    );
};

export default Topbar;